<script>
import uuid from 'uuid'
import {
  required,
  requiredIf,
  integer,
  minValue,
  maxValue,
  minLength
} from 'vuelidate/lib/validators'

export default {
  name: 'pkf-form',
  props: {
    value: { type: Object, default: () => {} }
  },

  data: vm => ({
    form: {
      specs: {
        color_outside: null,
        color_inside: null,
        selected_parts: [],
        other_parts: null
      },
      ...vm.value
    }
  }),
  computed: {
    otherSelected () {
      return [...this.form.specs.selected_parts].includes('other')
    }
  },
  validations: {
    form: {
      specs: {
        color_inside: {
          required
        },
        color_outside: {
          required
        },
        selected_parts: {
          required
        },
        other_parts: {
          required: requiredIf(model =>
            [...model.selected_parts].includes('other')
          )
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }

      return !this.$v.form.$invalid
    }
  }
}
</script>
<template>
  <div>
    <b-row class="mb-0">
      <b-col cols="6" class="mb-2">
        <g-form-error-wrapper :validations="$v.form.specs.color_outside">
          <template v-slot="{ errors, invalid }">
            <g-text-input
              v-model="form.specs.color_outside"
              class="mb-0"
              :label="$t('Color 1 (Outside)')"
              :error-messages="errors"
              v-on:blur="$v.form.specs.color_outside.$touch()"
              :is-valid="!invalid"
              :placeholder="$t('Leather color or number')"
            >
            </g-text-input>
          </template>
        </g-form-error-wrapper>
        <g-form-error-wrapper :validations="$v.form.specs.color_inside">
          <template v-slot="{ errors, invalid }">
            <g-text-input
              v-model="form.specs.color_inside"
              :label="$t('Color 2 (Inside)')"
              class="mb-0"
              :error-messages="errors"
              v-on:blur="$v.form.specs.color_inside.$touch()"
              :is-valid="!invalid"
              :placeholder="$t('Leather color or number')"
            >
            </g-text-input>
          </template>
        </g-form-error-wrapper>
      </b-col>
      <b-col cols="12" sm="12" md="6" lg="5" align-self="center"
        ><img
          src="@/assets/images/forms/bekleding.png"
          alt
          style="max-width: 100%; opacity: 0.8"
          class="dimg-fluid"
          height="180"
      /></b-col>
    </b-row>
    <g-form-error-wrapper :validations="$v.form.specs.selected_parts">
      <template v-slot="{ invalid }">
        <label :class="[{ 'text-danger': invalid }]">{{
          $t('Select at least one part')
        }}</label>
      </template></g-form-error-wrapper
    >
    <b-form-checkbox-group v-model="form.specs.selected_parts">
      <b-row>
        <b-col cols="12" class="mb-2">
          <b-form-checkbox id="seat_enabled" value="seat" name="seat_enabled">
            {{ $t('attribute.upholstry_part.seat') }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" class="mb-2">
          <b-form-checkbox id="back_enabled" value="back" name="back_enabled">
            {{ $t('attribute.upholstry_part.back') }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" class="mb-2">
          <b-form-checkbox
            id="headrest_enabled"
            value="headrest"
            name="headrest_enabled"
          >
            {{ $t('attribute.upholstry_part.headrest') }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" class="mb-2">
          <b-form-checkbox
            id="abduction_enabled"
            value="abduction"
            name="abduction_enabled"
          >
            {{ $t('attribute.upholstry_part.abduction') }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <b-form-checkbox
            id="other_enabled"
            value="other"
            name="other_enabled"
          >
            {{ $t('attribute.upholstry_part.other') }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <g-form-error-wrapper :validations="$v.form.specs.other_parts">
            <template v-slot="{ errors, invalid }">
              <b-form-group
                :class="{
                  'is-invalid': invalid,
                  'is-valid': !invalid
                }"
                class="mb-0"
                v-show="otherSelected"
              >
                <b-form-textarea
                  id="comments"
                  placeholder="Add the extra parts"
                  v-model="form.specs.other_parts"
                  class="mt-2"
                  rows="2"
                  max-rows="2"
                />
                <b-form-invalid-feedback
                  :id="`err_other_parts`"
                  class="m-0"
                  v-if="invalid"
                >
                  <slot name="errors">
                    <template v-if="!errors">Fix this field</template>
                    <template v-else>
                      <span
                        class="d-block form-text text-capitalize"
                        v-for="(err, idx) in errors"
                        :key="`err_other_parts_${idx}`"
                      >
                        {{ err }}
                      </span>
                    </template>
                  </slot>
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
          </g-form-error-wrapper>
        </b-col>
      </b-row>
    </b-form-checkbox-group>

    <p class="mt-3 mb-0 font-weight-bold text-danger">
      <i class="fas fa-exclamation-triangle mr-1" />
      {{ $t('IMPORTANT') }}
    </p>
    <p class="mt-0 mb-0 font-weight-light text-danger">
      {{
        $t(
          'Please do not forget to put the exact reference and color numbers/names on the foam parts!'
        )
      }}
    </p>
  </div>
</template>
